import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ProductCard } from '../shared/ProductCard';
import { HeadingText } from '../shared/HeadingText';
import { Section } from '../shared/Section';
import { useCatalog } from '../../contexts/CatalogContext';
import { founder } from '../../data/content';
import { fill } from '../../utils/copy';
import { quietLink, sectionHeading } from '../../ui/sections';
import { shelfPicks } from './aboutRules';
import type { AboutPage } from '../../core/types/pages';
type Props = {
  copy: AboutPage['shelf'];
};

/**
 * Haar eigen plank: drie producten die Sarah zelf kiest (Paginateksten › Over), elk met één zin
 * waarom. Niet de bestsellers van Home. Een stil raster: het bewegende moment is de filosofie.
 */
export function AboutShelf({
  copy
}: Props) {
  const {
    productById
  } = useCatalog();
  const picks = shelfPicks(copy.picks, productById);
  if (picks.length === 0) return null;
  return <Section tone="shell" labelledBy="about-shelf" data-id="element-5766" data-mp="17xulpdgtsiec">
      <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-5767" data-mp="3ea5920j5xvsn">
        <div className="max-w-2xl" data-id="element-5768" data-mp="39ait3jbya1g5">
          <h2 id="about-shelf" className={`${sectionHeading} text-ink`} data-id="element-5769" data-mp="39a93vxyqbybi">
            <HeadingText heading={copy.heading} data-id="element-5770" data-mp="34jkc0hj50zbu" />
          </h2>
          {copy.body && <p className="mt-6 text-[17px] leading-relaxed text-muted" data-id="element-5771" data-mp="34hfw117ys9v7">{fill(copy.body)}</p>}
        </div>
        {copy.cta && <Link to="/webshop" className={`${quietLink} text-ink`} data-id="element-5772" data-mp="2vjngbvybz07a">
            {fill(copy.cta)}
            <ArrowRightIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-5773" data-mp="2qjhwh1yayhzr" />
          </Link>}
      </div>

      <ul aria-label={`De plank van ${founder.firstName}`} className="mt-10 grid gap-x-6 gap-y-12 sm:grid-cols-3 lg:mt-12 lg:gap-x-10" data-id="element-5774" data-mp="2llzjn0h5zimh">
        {picks.map(({
        product,
        why
      }) => <li key={product.id} className="flex h-full flex-col" data-id="element-5775" data-mp="ju36xnj9g2q4">
            <ProductCard product={product} data-id="element-5776" data-mp="jr8p83rmsw0e" />
            {why && <p className="mt-5 border-t border-ink/15 pt-4 text-[15px] leading-relaxed text-muted" data-id="element-5777" data-mp="fshoznrvcy92">
                <span className="text-ink" data-id="element-5778" data-mp="299dz9zwwjbn5">{founder.firstName}:</span> {fill(why)}
              </p>}
          </li>)}
      </ul>
    </Section>;
}